/* KC Nadruk UI v2 (motyw, 10.10) — kreator nadrukow na stronie produktu.
 * Podglad (projekt / na ubraniu / na osobie) zamiast galerii + ustawienia wzoru w opcjach kc-options.
 * Ceny, pola, walidacja i koszyk zostaja w kc-options (kontrakt Notion bez zmian); kreator czyta wartosci przez window.KCO
 * i przed wyslaniem dokłada: properties[_kca] (JSON projektu do pliku druku), [_podglad] (PNG), widoczne ustawienia stylu,
 * dodatkowe zdjecia spoza kc-options. Obrazy z paczek kca-pack-N.bin (Range) – window.KCNadrukCfg ustawia sekcja motywu.
 * Zrodla: C:\Users\losvo\kc-nadruki\deploy (artefakt: artifact-v2\_src2.html). */
(function (global) {
  'use strict';
  var A = global.KCApparel, CFG = global.KCNadrukCfg;
  if (!A || !CFG) return;
  var doc = document;
  function el(t, c, txt) { var e = doc.createElement(t); if (c) e.className = c; if (txt != null) e.textContent = txt; return e; }

  // ================= paczki obrazow (Range) =================
  var PIDXP = null, BLOB = {}, WAIT = {}, PACKBUF = {};
  function index() { if (!PIDXP) PIDXP = fetch(CFG.packIndex).then(function (r) { return r.json(); }); return PIDXP; }
  function fetchKey(k) {
    if (WAIT[k]) return WAIT[k].p;
    var w = WAIT[k] = { cbs: [] };
    w.p = index().then(function (ix) {
      var e = ix.files[k]; if (!e) throw new Error('brak w paczce: ' + k);
      var url = CFG.packs[e[0] - 1], a = e[1], b = e[1] + e[2];
      return fetch(url, { headers: { Range: 'bytes=' + a + '-' + (b - 1) } }).then(function (r) {
        if (r.status === 206) return r.arrayBuffer();
        if (!r.ok) throw new Error('HTTP ' + r.status);
        // serwer zignorowal Range: cala paczka raz w pamieci, dalej wycinki
        if (!PACKBUF[e[0]]) PACKBUF[e[0]] = r.arrayBuffer();
        return PACKBUF[e[0]].then(function (buf) { return buf.slice(a, b); });
      }).then(function (buf) { BLOB[k] = URL.createObjectURL(new Blob([buf], { type: e[3] })); return BLOB[k]; });
    });
    w.p.then(function () { var c = w.cbs; w.cbs = []; c.forEach(function (f) { try { f(); } catch (x) {} }); },
      function (err) { console.warn('[kc-nadruk]', err.message || err); });
    return w.p;
  }
  // silnik: obraz o adresie kca:<klucz> -> blob-URL (albo null = jeszcze sie laduje, potem cb)
  global.KCApparelResolve = function (url, cb) {
    if (typeof url !== 'string' || url.indexOf('kca:') !== 0) return undefined;
    var k = url.slice(4);
    if (BLOB[k]) return BLOB[k];
    fetchKey(k); if (cb && WAIT[k].cbs.indexOf(cb) < 0) WAIT[k].cbs.push(cb);
    return null;
  };
  var KIMG = {};
  function kimg(k) { // obraz z paczki dla UI (osoby, przyklady): Image gdy gotowy, inaczej null + rysuj po wczytaniu
    var i = KIMG[k];
    if (i) return i.complete && i.naturalWidth ? i : null;
    if (!BLOB[k]) { if (!WAIT[k] || WAIT[k].cbs.indexOf(draw) < 0) { fetchKey(k); WAIT[k].cbs.push(draw); } return null; }
    i = KIMG[k] = new Image(); i.onload = function () { draw(); }; i.src = BLOB[k]; return null;
  }
  function kload(k) { return fetchKey(k).then(function (u) { return new Promise(function (res) { var i = new Image(); i.onload = function () { res(i); }; i.onerror = function () { res(null); }; i.src = u; }); }); }

  // ================= produkty =================
  var TONE = function (def) { return { k: 'tone', l: 'Zdjęcia', type: 'choice', opts: ['kolor', 'czb', 'vintage'], names: { kolor: 'Kolorowe', czb: 'Czarno-białe', vintage: 'Vintage' }, def: def, s: 1 }; };
  var GAP = function (def) { return { k: 'gap', l: 'Odstępy między zdjęciami', type: 'choice', opts: ['brak', 'waskie', 'szerokie'], names: { brak: 'Bez odstępów', waskie: 'Wąskie', szerokie: 'Szerokie' }, def: def, s: 1 }; };
  var FRAMEF = { k: 'frame', l: 'Ramki polaroidów', type: 'choice', opts: ['vintage', 'bialy', 'czarny'], names: { vintage: 'Vintage', bialy: 'Białe', czarny: 'Czarne' }, def: 'vintage', s: 1, show: { style: ['inicjaly', 'podpis', 'finding', 'forever2', 'forever', 'walentynki'] } };
  var INK2 = ['Czarny', 'Czerwony'], INK6 = ['Czerwony', 'Czarny', 'Biały', 'Różowy', 'Granatowy', 'Brązowy'];
  var DZ = { k: 'style', l: 'Wzór', type: 'choice', thumbs: 1, opts: ['inicjaly', 'podpis', 'finding', 'forever2', 'forever', 'walentynki'], names: { inicjaly: 'Inicjały', podpis: 'I love you', finding: 'Finding you', forever2: 'Forever Young', forever: 'Jeden polaroid', walentynki: 'Zdjęcia + napis' }, def: 'inicjaly' };
  var DZTXT = [
    { k: 'initials', l: 'Inicjały (np. K+J)', def: 'K+J', show: { style: 'inicjaly' } },
    { k: 'textP', l: 'Napis', def: 'I love you', show: { style: 'podpis' } },
    { k: 'textFi', l: 'Napis (| = nowa linia)', def: 'Finding you was always the plan ♡', show: { style: 'finding' }, max: 90 },
    { k: 'textF2', l: 'Napis', def: 'Forever Young', show: { style: 'forever2' } },
    { k: 'textV', l: 'Napis (| = nowa linia)', def: "Happy Valentine's Day", show: { style: 'walentynki' } },
    { k: 'textF', l: 'Napis na ramce', def: 'FOREVER YOUNG', show: { style: 'forever' } },
    { k: 'year', l: 'Rok pod napisem', def: '1976', show: { style: 'forever' } }];
  var DZSTY = [TONE('vintage'), FRAMEF, { k: 'tcolor', l: 'Kolor napisu', type: 'choice', opts: ['Oryginalny', 'Czarny', 'Czerwony', 'Różowy', 'Biały'], def: 'Oryginalny', s: 1 }];
  var DZPH = [{ src: 'img2/m1.jpg' }, { src: 'img2/k3.jpg', show: { style: ['inicjaly', 'podpis', 'finding', 'forever2', 'walentynki'] } }];
  // photos: { f: id pola file kc-options } albo { x: etykieta w koszyku } (dodatkowe zdjecie wgrywane w kreatorze)
  // kco: klucz pola wzoru -> id pola kc-options (wartosc z opcji sklepu); pozostale pola = ustawienia kreatora
  var P = {
    '16281445728605': { tpl: 'pupil', cutout: true, photos: [{ f: 'file-1', n: 'Pupil', src: 'img/dog.jpg', cut: 'img/dog-cut.png' }],
      kco: { name: 'text-name', date: 'text-date' }, fields: [{ k: 'name', l: 'Imię pupila', def: 'Zuzia' }, { k: 'date', l: 'Rok (EST.)', def: '2020' }, TONE('kolor')] },
    '16281445335389': { tpl: 'kolaz', photos: [1, 2, 3, 4, 5, 6].map(function (i) { return { f: 'kc-photo-' + i, src: 'img2/' + ['c1', 'c4', 'c9', 'c7', 'c10', 'c12'][i - 1] + '.jpg' }; }),
      kco: { word: 'kc-word', wordColor: 'kc-word-color', name: 'kc-name', since: 'kc-since', tagline: 'kc-tagline' },
      fields: [{ k: 'word', l: 'Duży napis', def: 'WIFEY' }, { k: 'name', l: 'Imię', def: 'Monika' }, { k: 'since', l: 'Data (since)', def: '03.07.2025' }, { k: 'tagline', l: 'Tekst', def: '' },
        { k: 'wordColor', l: 'Kolor napisu', def: 'Czarny' }, TONE('czb'), GAP('brak'), { k: 'reps', l: 'Ile razy napis', type: 'choice', opts: ['3', '1'], names: { 3: 'Potrójny', 1: 'Pojedynczy' }, def: '3', s: 1 },
        { k: 'bottomColor', l: 'Kolor imienia i daty', type: 'choice', opts: INK2, def: 'Czarny', s: 1 }] },
    '16256884244829': { tpl: 'rysunek', photos: [{ f: 'kc-photo-1', n: 'Rysunek', src: 'img/rysunek-kartka.jpg', noAdj: 1 }],
      note: 'Wystarczy zdjęcie rysunku telefonem – z góry, przy dziennym świetle. Kartkę, stół i cienie usuwamy automatycznie, na ubraniu zostaje sam rysunek.',
      fields: [{ k: 'paper', l: 'Tło kartki', type: 'choice', opts: ['normalne', 'mocne', 'delikatne', 'brak'], names: { normalne: 'Usuń', mocne: 'Usuń mocniej', delikatne: 'Usuń delikatnie', brak: 'Zostaw kartkę' }, def: 'normalne', s: 1 },
        { k: 'lines', l: 'Czarne kreski na ciemnym ubraniu', type: 'choice', opts: ['biale', 'czarne'], names: { biale: 'Zamień na białe', czarne: 'Zostaw czarne' }, def: 'biale', s: 1, dark: 1 }] },
    '16256881099101': { tpl: 'bestdad', photos: [1, 2, 3, 4].map(function (i) { return { f: 'kc-photo-' + i, src: 'img2/k' + i + '.jpg' }; }),
      kco: { name: 'kc-req-text', under: 'kc-date' }, fields: [{ k: 'name', l: 'Imię i nazwisko', def: 'Artur Kowalik' }, { k: 'under', l: 'Data', def: '10.11.2024' }, TONE('czb')] },
    '16256881623389': { tpl: 'bestdadever', photos: [1, 2, 3].map(function (i) { return { f: 'kc-photo-' + i, src: 'img2/' + ['k1', 'k4', 'k3'][i - 1] + '.jpg' }; }),
      kco: { under: 'kc-date' }, fields: [{ k: 'under', l: 'Tekst', def: '' }, TONE('czb')] },
    '16256885686621': { tpl: 'dziecinstwo', photos: [{ f: 'kc-photo-1', src: 'img2/m1.jpg' }, { f: 'kc-photo-2', src: 'img2/k3.jpg', show: DZPH[1].show }],
      kco: { initials: 'kc-req-text', textP: 'kc-req-text', textFi: 'kc-req-text', textF2: 'kc-req-text', textV: 'kc-req-text', textF: 'kc-req-text' },
      fields: [DZ].concat(DZTXT, DZSTY) },
    '15938481520989': { tpl: 'dziecinstwo', photos: [{ f: 'file-1', src: 'img2/m1.jpg' }, { x: 'Zdjęcie (2)', src: 'img2/k3.jpg', show: DZPH[1].show }],
      kco: { initials: 'text-6' }, fields: [DZ].concat(DZTXT, DZSTY) },
    '16256882835805': { tpl: 'tatacorka', photos: [],
      fields: [{ k: 'top', l: 'Kto', type: 'choice', opts: ['TATA', 'MAMA'], names: { TATA: 'Tata', MAMA: 'Mama' }, def: 'TATA' },
        { k: 'sub', l: 'Z kim', type: 'choice', opts: ['i córka', 'i syn'], names: { 'i córka': 'Córka', 'i syn': 'Syn' }, def: 'i córka' },
        { k: 'date', l: 'Rok (EST.)', def: '2020' }, { k: 'line', l: 'Napis na dole', def: 'Best Friends For Life', max: 30 }] },
    '16062684070237': { tpl: 'wlasny', photos: [{ f: 'file-1', n: 'Grafika', src: 'img2/c5.jpg', noAdj: 1 }],
      kco: { text: 'text-1', textPos: 'kc-text-pos', font: 'google-font-1' }, noDef: { text: 1 },
      fields: [{ k: 'text', l: 'Tekst', def: '' }, { k: 'textPos', l: 'Tekst', def: 'Pod wzorem' }, { k: 'font', l: 'Czcionka', def: 'Montserrat' }] },
    // 11.10 nowe wzory (folder ideas): Chata. / MAFFIN / FLORENCIA / pupil-ilustracja na bluzie
    '16628370571613': { tpl: 'pupilscript', cutout: true, photos: [{ f: 'file-1', n: 'Pupil', src: 'img3/buldog.jpg', cut: 'img3/buldog-cut.png' }],
      kco: { name: 'text-name' }, fields: [{ k: 'name', l: 'Imię pupila', def: 'Chata' },
        { k: 'font', l: 'Pismo', type: 'choice', opts: ['Eleganckie', 'Odręczne', 'Zaokrąglone'], def: 'Eleganckie', s: 1 },
        { k: 'nameColor', l: 'Kolor imienia', type: 'choice', opts: INK6, def: 'Czerwony', s: 1 },
        { k: 'dot', l: 'Kropka po imieniu', type: 'choice', opts: ['tak', 'nie'], names: { tak: 'Tak', nie: 'Bez kropki' }, def: 'tak', s: 1 }, TONE('kolor')] },
    '16628370669917': { tpl: 'pupilrepeat', cutout: true, photos: [{ f: 'file-1', n: 'Pupil', src: 'img3/pudel.jpg', cut: 'img3/pudel-cut.png' }],
      kco: { name: 'text-name', small: 'text-small' }, fields: [{ k: 'name', l: 'Imię pupila', def: 'Maffin' }, { k: 'small', l: 'Mały napis', def: '' },
        { k: 'rows', l: 'Ile razy imię', type: 'choice', opts: ['5', '7', '9'], def: '7', s: 1 },
        { k: 'outline', l: 'Środkowe napisy', type: 'choice', opts: ['kontur', 'brak'], names: { kontur: 'Kontur', brak: 'Pełne' }, def: 'kontur', s: 1 }, TONE('kolor')] },
    '16628370702685': { tpl: 'pupilvintage', cutout: true, photos: [{ f: 'file-1', src: 'img3/buldog.jpg', cut: 'img3/buldog-cut.png' }, { f: 'file-2', src: 'img3/spaniel.jpg', cut: 'img3/spaniel-cut.png' },
        { f: 'file-3', src: 'img3/pudel.jpg', cut: 'img3/pudel-cut.png' }, { f: 'file-4', src: 'img/dog.jpg', cut: 'img/dog-cut.png' }, { f: 'file-5', src: 'img3/kot-czarny.jpg', cut: 'img3/kot-czarny-cut.png' }],
      note: 'Od 1 do 5 zwierzaków. Zdjęcie nr 1 jest na środku, z przodu.',
      kco: { name: 'text-name' }, fields: [{ k: 'name', l: 'Wielki napis', def: 'Kowalscy' },
        { k: 'color90', l: 'Kolor', type: 'choice', opts: ['Fioletowy', 'Niebieski', 'Różowy', 'Czerwony', 'Zielony', 'Pomarańczowy'], def: 'Fioletowy', s: 1 },
        { k: 'bolts', l: 'Błyskawice', type: 'choice', opts: ['tak', 'nie'], names: { tak: 'Tak', nie: 'Bez' }, def: 'tak', s: 1 }, TONE('kolor')] },
    '16628370735453': { tpl: 'pupilart', cutout: true, photos: [{ f: 'file-1', n: 'Pupil', src: 'img3/spaniel.jpg', cut: 'img3/spaniel-art.png', art: 1 }],
      note: 'Podgląd jest poglądowy. Po zamówieniu robimy z Twojego zdjęcia prawdziwą ilustrację i wysyłamy do akceptacji przed drukiem.',
      kco: { name: 'text-name' }, fields: [{ k: 'name', l: 'Imię pupila', def: 'Marcela' },
        { k: 'font', l: 'Pismo', type: 'choice', opts: ['Odręczne', 'Zaokrąglone'], def: 'Odręczne', s: 1 },
        { k: 'nameColor', l: 'Kolor imienia', type: 'choice', opts: INK6, def: 'Biały', s: 1 },
        { k: 'namePos', l: 'Imię', type: 'choice', opts: ['bok', 'środek'], names: { bok: 'Z boku', 'środek': 'Na środku' }, def: 'bok', s: 1 }] }
  };

  var KCO = null, M = null, PID = '', S = { vals: {}, pos: null, scale: 1, edit: null, touched: false }, view = 'ubranie', full = true, LAST = null, OFF = { x: 0, y: 0 };
  var MAN = null, OSOBA = null, ROOT = null, ui = {}, XPH = {}, PHC = {}, DEMO = {}, GALLERY = [];
  var TYPES = { tee: 'Koszulka', crew: 'Bluza', hoodie: 'Bluza z kapturem' };
  var PLACE = { 'Przód': 'chest', 'Plecy': 'back', 'Lewa pierś': 'left', 'Prawa pierś': 'right' };
  var PLN = { 'Biala': 'Biała', 'Rozowa': 'Różowa', 'NIebieska': 'Niebieska', 'Blekitna': 'Błękitna', 'Bezowa': 'Beżowa', 'Brazowa': 'Brązowa' };

  // ================= odczyt opcji sklepu =================
  function vis(id) { return KCO.isVisible ? KCO.isVisible(id) : true; }
  function kv(id) { var v = id && vis(id) ? KCO.values[id] : ''; return Array.isArray(v) ? v.join(', ') : (v || ''); }
  function typeRaw() { return String(KCO.values['image-swatches-1'] || ''); }
  function gType() {
    var t = typeRaw().toLowerCase();
    if (/bez kaptura|crew/.test(t)) return 'crew';
    if (/kaptur|hood|rozpin/.test(t)) return 'hoodie';
    if (/bluza/.test(t)) return 'crew';
    return 'tee';
  }
  function isZip() { return /rozpin/i.test(typeRaw()); }
  function gPlace() {
    var p = String(KCO.values['image-swatches-2'] || '').toLowerCase();
    if (/plec|back/.test(p)) return 'Plecy';
    if (/lewej|left/.test(p)) return 'Lewa pierś';
    if (/prawej|right/.test(p)) return 'Prawa pierś';
    return 'Przód';
  }
  function gSize() { return kv('buttons-1') || kv('buttons-2') || ''; }
  function colorsFor(type) {
    var v = MAN && MAN.widoki[{ tee: 'koszulka', crew: 'bluza', hoodie: 'kaptur' }[type] + '-przod'];
    return v ? Object.keys(v.kolory).map(function (k) { var n = k.split(' - ')[0]; return { val: k, name: PLN[n] || n, hex: v.kolory[k].hex }; }) : [];
  }
  function plain(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ł/g, 'l'); }
  function gColor() {
    var raw = '';
    ['image-swatches-6', 'image-swatches-5', 'image-swatches-4', 'kc-zip-colors'].forEach(function (id) { if (!raw && KCO.els[id] && vis(id) && KCO.values[id]) raw = KCO.values[id]; });
    var cs = colorsFor(gType()), want = plain(raw.split(' - ')[0]);
    var hit = cs.filter(function (c) { return c.val === raw; })[0] || cs.filter(function (c) { return plain(c.val.split(' - ')[0]) === want; })[0]
      || cs.filter(function (c) { return plain(c.val).slice(0, 4) === want.slice(0, 4); })[0];
    if (!hit && /military|khaki|oliw/.test(want)) hit = cs.filter(function (c) { return /zielon/.test(plain(c.val)); })[0];
    return hit || cs.filter(function (c) { return /czarn/.test(plain(c.val)); })[0] || cs[0] || { val: 'Czarna - Black', name: 'Czarna', hex: '#1b1b1b' };
  }

  // ================= zdjecia =================
  function shown(f) {
    if (!f.show) return true;
    return Object.keys(f.show).every(function (k) { var v = f.show[k], cur = S.vals[k]; return Array.isArray(v) ? v.indexOf(cur) >= 0 : cur === v; });
  }
  function inputFor(fid) { return ROOT.querySelector('input[data-kco-file-id="' + fid + '"]'); }
  function mkPhoto(file, slot, cache) {
    var c = cache[slot];
    if (c && c.file === file) return c.ph;
    var ph = { img: null, loading: true, name: file.name };
    cache[slot] = { file: file, ph: ph };
    if (!/^image\/(jpeg|png|webp|gif)/.test(file.type)) { ph.loading = false; ph.unsupported = true; return ph; }
    var im = new Image(), u = URL.createObjectURL(file);
    im.onload = function () {
      ph.img = im; ph.url = u; ph.loading = false;
      var d = M.photos[slot] || {};
      if (M.cutout) cutout(ph);
      renderBox(); draw();
    };
    im.onerror = function () { ph.loading = false; ph.unsupported = true; renderBox(); draw(); };
    im.src = u;
    return ph;
  }
  var cutP = null;
  function cutout(ph) {
    ui.busy.hidden = false;
    if (!cutP) cutP = global.KCCutout ? Promise.resolve() : loadScript(CFG.ort).then(function () { return loadScript(CFG.cutout); });
    cutP.then(function () { global.KCCutout.modelUrl = CFG.model; return global.KCCutout.run(ph.img); })
      .then(function (c) { ph.cut = c; }).catch(function (e) { ph.cutError = true; console.warn('[kc-nadruk] cutout', e); })
      .then(function () { ui.busy.hidden = true; draw(); });
  }
  function realPhoto(i) {
    var d = M.photos[i]; if (!d) return null;
    if (d.f) { if (!vis(d.f)) return null; var inp = inputFor(d.f), f = inp && inp.files && inp.files[0]; if (!f) { delete PHC[i]; return null; } return mkPhoto(f, i, PHC); }
    var x = XPH[i]; return x ? mkPhoto(x, i, PHC) : null;
  }
  function anyReal() { for (var i = 0; i < M.photos.length; i++) if (realPhoto(i)) return true; return false; }
  function demoPhoto(i) {
    var d = M.photos[i]; if (!d || !d.src) return null;
    if (DEMO[i]) return DEMO[i];
    var ph = DEMO[i] = { img: null, demo: true, art: !!d.art };
    kload(d.src).then(function (im) { ph.img = im; ph.url = BLOB[d.src]; if (d.cut) return kload(d.cut).then(function (c) { ph.cut = c; }); }).then(function () { renderBox(); draw(); });
    return ph;
  }
  function photos() {
    var real = anyReal();
    return M.photos.map(function (d, i) {
      if (d.show && !shown(d)) return null;
      var r = realPhoto(i); if (r) return r.img ? r : null;
      if (real) return null;
      var dm = demoPhoto(i); return dm && dm.img ? dm : null;
    });
  }

  // ================= dane wzoru =================
  function fieldVal(f) {
    var id = M.kco && M.kco[f.k];
    if (!id) return S.vals[f.k];
    var v = kv(id);
    if (f.k === 'word' && /wlasny|własny/i.test(v)) v = kv('kc-word-custom');
    if (v) return v;
    if (M.noDef && M.noDef[f.k]) return '';
    return S.touched ? '' : (f.def || '');
  }
  function data() {
    var d = { photos: photos() };
    M.fields.forEach(function (f) { var v = fieldVal(f); if (v != null) d[f.k] = v; });
    if (d.reps) d.reps = +d.reps;
    if (M.tpl === 'dziecinstwo') {
      var st = S.vals.style;
      d.text = { walentynki: d.textV, forever: d.textF, podpis: d.textP, finding: d.textFi, forever2: d.textF2 }[st];
      d.textColor = S.vals.tcolor; d.vintage = S.vals.tone === 'vintage';
    }
    if (M.tpl === 'wlasny' && !/^#/.test(kv('color-picker-1'))) d.textColor = ''; else if (M.tpl === 'wlasny') d.textColor = kv('color-picker-1');
    return d;
  }

  // ================= osoba =================
  function personsFor(type) {
    if (!OSOBA) return [];
    var side = PLACE[gPlace()] === 'back' ? 'back' : 'front';
    return Object.keys(OSOBA).filter(function (k) { return OSOBA[k].typ === type; })
      .sort(function (a, b) { return (OSOBA[a].strona === side ? 0 : 1) - (OSOBA[b].strona === side ? 0 : 1); });
  }
  function layer(W, H) { var l = el('canvas'); l.width = W; l.height = H; return l; }
  function renderPerson(c, key, big, col) {
    var o = OSOBA[key], real = o.kolory && o.kolory[col.val], fk = real || key;
    var base = kimg('osoba/' + fk + '.jpg'), mask = kimg('osoba/' + fk + '-mask.png'), shade = kimg('osoba/' + fk + '-shade.png');
    var W = c.width, H = c.height, x = c.getContext('2d');
    if (!base || !mask || !shade) { x.fillStyle = '#E4DBCD'; x.fillRect(0, 0, W, H); return false; }
    x.drawImage(base, 0, 0, W, H);
    var hex = col.hex, n = parseInt(hex.slice(1), 16), lum = (0.299 * (n >> 16) + 0.587 * ((n >> 8) & 255) + 0.114 * (n & 255)) / 255;
    if (!real && lum < 0.93) {
      var t = layer(W, H), tx = t.getContext('2d');
      tx.fillStyle = hex; tx.fillRect(0, 0, W, H);
      tx.globalCompositeOperation = 'multiply'; tx.drawImage(shade, 0, 0, W, H); if (lum < 0.2) tx.drawImage(shade, 0, 0, W, H);
      tx.globalCompositeOperation = 'screen'; tx.globalAlpha = lum < 0.12 ? 0.05 : (lum < 0.35 ? 0.1 : 0.06); tx.drawImage(shade, 0, 0, W, H); tx.globalAlpha = 1;
      tx.globalCompositeOperation = 'destination-in'; tx.drawImage(mask, 0, 0, W, H);
      x.drawImage(t, 0, 0);
    }
    var pl = gPlace();
    if (o.strona !== (PLACE[pl] === 'back' ? 'back' : 'front')) return true;
    var p = o.pole, place = PLACE[pl] || 'chest', px = p[0] * W, py = p[1] * H, pw = p[2] * W, ph = p[3] * H;
    if (place === 'left' || place === 'right') { var sw = pw * 0.34; px = place === 'left' ? px + pw - sw : px; pw = sw; ph = sw * 1.1; py += ph * 0.05; }
    var dd = data(), t2 = A.dims(M.tpl, dd), sc = Math.min(pw / t2.w, ph / t2.h) * (S.scale || 1), dw = t2.w * sc, dh = t2.h * sc;
    var cxp = px + pw / 2, top = py;
    if (S.pos && place !== 'left' && place !== 'right') { cxp += S.pos.x / 100 * W * o.bbox[2] * 0.95; top += S.pos.y / 100 * W * o.bbox[2] * 0.95; }
    var dc = layer(Math.max(40, Math.round(dw * (big ? 1.6 : 1))), Math.max(40, Math.round(dh * (big ? 1.6 : 1))));
    A.renderDesign(dc, M.tpl, Object.assign(dd, { garment: hex }));
    var keep = layer(dc.width, dc.height); keep.getContext('2d').drawImage(dc, 0, 0);
    var dx = dc.getContext('2d'), ssx = shade.naturalWidth / W, ssy = shade.naturalHeight / H, X0 = cxp - dw / 2;
    dx.globalCompositeOperation = 'multiply'; dx.globalAlpha = 0.55; dx.drawImage(shade, X0 * ssx, top * ssy, dw * ssx, dh * ssy, 0, 0, dc.width, dc.height);
    dx.globalAlpha = 1; dx.globalCompositeOperation = 'destination-in'; dx.drawImage(keep, 0, 0);
    var m2 = layer(W, H), mx = m2.getContext('2d'); mx.drawImage(dc, X0, top, dw, dh); mx.globalCompositeOperation = 'destination-in'; mx.drawImage(mask, 0, 0, W, H);
    x.globalAlpha = 0.96; x.drawImage(m2, 0, 0); x.globalAlpha = 1;
    return true;
  }
  // projekt: sam nadruk bez tla (jasny wzor na ciemne ubranie dostaje cien, zeby byl czytelny)
  function flatNoBg(c, hex, dd) {
    var S0 = c.width, x = c.getContext('2d'), dk = A.isDark(hex), t = A.dims(M.tpl, dd);
    x.clearRect(0, 0, S0, c.height);
    if (!t) return null;
    var box = S0 * 0.86, sc = Math.min(box / t.w, box / t.h), w = t.w * sc, h = t.h * sc;
    var dc = layer(Math.round(w * 2), Math.round(h * 2));
    var d = A.renderDesign(dc, M.tpl, Object.assign({}, dd, { garment: hex }));
    if (dk) { x.shadowColor = 'rgba(20,18,16,0.55)'; x.shadowBlur = S0 * 0.012; }
    x.drawImage(dc, (S0 - w) / 2, (c.height - h) / 2, w, h); x.shadowColor = 'transparent';
    return { design: d };
  }

  // ================= rysowanie =================
  var raf = 0, roomT = 0;
  function draw() { if (raf || !M) return; raf = requestAnimationFrame(function () { raf = 0; drawNow(); clearTimeout(roomT); roomT = setTimeout(drawRooms, 160); }); }
  function mockOpts(dd, col) { var pl = PLACE[gPlace()] || 'chest'; return { type: gType(), color: col.val, place: pl, tpl: M.tpl, data: dd, pos: S.pos, scale: S.scale }; }
  function drawNow() {
    if (ui.stick) setTimeout(ui.stick, 0);
    var cv = ui.cv, col = gColor(), hex = col.hex, dd = data(), note = '', badge = '', pl = gPlace();
    if (A.isDark && M.fields.some(function (f) { return f.dark; })) renderBox.dark !== A.isDark(hex) && (renderBox.dark = A.isDark(hex), renderBox());
    ui.zoom.hidden = view !== 'ubranie'; ui.zoom.textContent = full ? 'Przybliż nadruk' : 'Całe ubranie';
    LAST = null;
    if (view === 'projekt') {
      cv.width = 1000; cv.height = 1000;
      var f = flatNoBg(cv, hex, dd);
      badge = 'Twój projekt'; note = 'Tak wygląda sam nadruk. Poniżej zobaczysz go na ubraniu i na osobie.';
      warnLow(f && f.design);
    } else if (view === 'ubranie') {
      var Z = full ? 1 : 1.55, oc = layer(Math.round(1000 * Z), Math.round(1000 * Z));
      var o = Object.assign(mockOpts(dd, col), { shadow: true });
      var r = A.renderMock(oc, o);
      if (r && r.pending) r = A.renderMock(oc, o);
      cv.width = 1000; cv.height = 1000; var x = cv.getContext('2d'); x.clearRect(0, 0, 1000, 1000);
      if (r && r.frame && !full) {
        var fx = r.frame.x + r.frame.w / 2, fy = r.frame.y + r.frame.h * 0.42;
        OFF = { x: Math.max(0, Math.min(oc.width - 1000, fx - 500)), y: Math.max(0, Math.min(oc.height - 1000, fy - 500)) };
      } else OFF = { x: 0, y: 0 };
      x.drawImage(oc, -OFF.x, -OFF.y);
      if (r && r.rect) { LAST = r; if (S.pos) S.pos = r.pos; }
      badge = TYPES[gType()] + ' · ' + col.name.toLowerCase() + ' · ' + pl.toLowerCase();
      note = r && r.cm ? 'Nadruk ok. ' + Math.round(r.cm.w) + ' × ' + Math.round(r.cm.h) + ' cm. Przeciągnij wzór, żeby go przesunąć.' : '';
      if (isZip()) note = 'Podgląd na bluzie z kapturem – bluza rozpinana ma zamek na środku. ' + note;
      warnLow(r && r.design);
    } else if (view.indexOf('osoba:') === 0) {
      var key = view.slice(6), op = OSOBA && OSOBA[key];
      if (!op || op.typ !== gType()) { view = 'ubranie'; return drawNow(); }
      cv.width = 900; cv.height = Math.round(900 * op.h / op.w);
      renderPerson(cv, key, true, col);
      badge = op.label; note = op.strona !== (PLACE[pl] === 'back' ? 'back' : 'front') ? 'Nadruk jest na ' + (PLACE[pl] === 'back' ? 'plecach' : 'przodzie') + ' – wybierz drugie zdjęcie poniżej.' : 'Zdjęcie poglądowe: ' + TYPES[gType()].toLowerCase() + ' w kolorze ' + col.name.toLowerCase() + '.';
    } else { // zdjecie produktu ze sklepu
      var g = GALLERY[+view.slice(5)], gi = g && g.img;
      if (gi && gi.complete && gi.naturalWidth) { cv.width = 1000; cv.height = Math.round(1000 * gi.naturalHeight / gi.naturalWidth); cv.getContext('2d').drawImage(gi, 0, 0, cv.width, cv.height); }
      badge = 'Zdjęcie produktu'; note = 'Przykład z naszej pracowni. Twój projekt zobaczysz w podglądzie powyżej.';
    }
    ui.badge.textContent = badge;
    if (!ui.note.dataset.low) ui.note.textContent = note;
    var demo = M.photos.length && !anyReal();
    ui.demo.hidden = !demo;
  }
  function warnLow(d) {
    var ph = data().photos, low = d && A.quality(d).some(function (q, i) { return q.low && !(ph[i] && ph[i].demo); });
    ui.note.dataset.low = low ? '1' : '';
    if (low) ui.note.textContent = 'Jedno z Twoich zdjęć ma małą rozdzielczość – na nadruku może wyjść nieostro. Najlepiej wgraj oryginał z telefonu.';
  }
  function drawRooms() {
    var g = ui.rooms, type = gType();
    var items = [{ v: 'projekt', l: 'Projekt' }, { v: 'ubranie', l: 'Na ubraniu' }]
      .concat(personsFor(type).map(function (k) { return { v: 'osoba:' + k, l: 'Na osobie', k: k }; }))
      .concat(GALLERY.map(function (x, i) { return { v: 'foto:' + i, l: 'Zdjęcie', f: x }; }));
    var sig = items.map(function (i) { return i.v; }).join('|');
    if (g.dataset.sig !== sig) {
      g.innerHTML = ''; g.dataset.sig = sig;
      items.forEach(function (it) {
        var b = el('button', 'kca-room'); b.type = 'button'; b.dataset.v = it.v;
        if (it.f) { var im = el('img'); im.src = it.f.thumb; im.alt = ''; im.loading = 'lazy'; b.appendChild(im); }
        else { var c = el('canvas'); c.width = 180; c.height = it.k ? 240 : 180; b.appendChild(c); }
        b.appendChild(el('span', '', it.l));
        b.onclick = function () { view = it.v; full = true; draw(); };
        g.appendChild(b);
      });
    }
    var col = gColor(), hex = col.hex, dd = data();
    g.querySelectorAll('.kca-room').forEach(function (b) {
      var v = b.dataset.v; b.classList.toggle('is-on', v === view);
      var c = b.querySelector('canvas'); if (!c) return;
      if (v === 'projekt') flatNoBg(c, hex, dd);
      else if (v === 'ubranie') { var oc = layer(360, 360); A.renderMock(oc, mockOpts(dd, col)); var x = c.getContext('2d'); x.clearRect(0, 0, 180, 180); x.drawImage(oc, 0, 0, 180, 180); }
      else renderPerson(c, v.slice(6), false, col);
    });
    drawThumbs();
  }

  // ================= panel kreatora w opcjach =================
  function chips(box, opts, val, names, onPick) {
    box.innerHTML = '';
    opts.forEach(function (o) {
      var b = el('button', 'kcp-chip' + (String(o) === String(val) ? ' is-on' : ''), names && names[o] ? names[o] : o); b.type = 'button';
      b.onclick = function () { onPick(o); }; box.appendChild(b);
    });
  }
  function field(f, box) {
    var w = el('div', 'kcp-field'); w.appendChild(el('span', 'kcp-label', f.l));
    if (f.type === 'choice' && f.thumbs) {
      var g = el('div', 'kca-thumbs');
      f.opts.forEach(function (o) {
        var b = el('button', 'kca-thumb' + (o === S.vals[f.k] ? ' is-on' : '')); b.type = 'button'; b.dataset.o = o;
        var c = el('canvas'); c.width = 240; c.height = 240; b.appendChild(c); b.appendChild(doc.createTextNode(f.names[o] || o));
        b.onclick = function () { S.vals[f.k] = o; renderBox(); draw(); }; g.appendChild(b);
      });
      w.appendChild(g); ui.thumbs = g; ui.thumbsF = f;
    } else if (f.type === 'choice') {
      var c = el('div', 'kcp-chips'); chips(c, f.opts, S.vals[f.k], f.names, function (o) { S.vals[f.k] = o; renderBox(); draw(); }); w.appendChild(c);
    } else {
      var i = el('input', 'kcp-input'); i.type = 'text'; i.value = S.vals[f.k] || ''; i.maxLength = f.max || 32;
      i.oninput = function () { S.vals[f.k] = i.value; draw(); }; w.appendChild(i);
    }
    box.appendChild(w);
  }
  function ownFields() { return M.fields.filter(function (f) { return !(M.kco && M.kco[f.k]) && shown(f) && !(f.dark && !renderBox.dark); }); }
  function renderBox() {
    var box = ui.box; if (!box) return;
    box.innerHTML = ''; ui.thumbs = null;
    // zdjecia: miniatury + kadr (zdjecia z opcji sklepu) i wgrywanie dodatkowych
    var slots = M.photos.map(function (d, i) { return { d: d, i: i }; }).filter(function (s) { return !s.d.show || shown(s.d); });
    function slotOn(s) { var ph = realPhoto(s.i); return !!(ph && ph.img && !s.d.noAdj && !M.cutout); }
    var showSlots = slots.some(slotOn);
    if (showSlots) {
      var lab = el('div', 'kcp-field');
      lab.appendChild(el('span', 'kcp-label', 'Kadr zdjęć – kliknij „Kadr”, żeby wybrać fragment'));
      var sl = el('div', 'kcp-slots');
      slots.forEach(function (s) {
        var d = s.d, i = s.i, ph = realPhoto(i);
        if (!slotOn(s)) return;
        var c = el('div', 'kcp-slot is-on');
        if (ph && ph.url) c.style.backgroundImage = 'url("' + ph.url + '")';
        c.appendChild(el('span', 'n', String(i + 1)));
        if (ph && ph.img && !d.noAdj && !M.cutout) { var ad = el('button', 'adj' + (S.edit === i ? ' is-on' : ''), 'Kadr'); ad.type = 'button'; ad.onclick = function (e) { e.preventDefault(); e.stopPropagation(); S.edit = S.edit === i ? null : i; renderBox(); }; c.appendChild(ad); }
        sl.appendChild(c);
      });
      lab.appendChild(sl);
      box.appendChild(lab);
      if (S.edit != null && realPhoto(S.edit) && realPhoto(S.edit).img) box.appendChild(cropEditor(S.edit));
    }
    renderX(); syncSlots(); if (ui.multi) ui.multi(); placeBoxes();
    var own = ownFields();
    own.filter(function (f) { return !f.s; }).forEach(function (f) { field(f, box); });
    var st = own.filter(function (f) { return f.s; });
    if (st.length) { var h = el('div', 'kca-sec', 'Styl'); box.appendChild(h); st.forEach(function (f) { field(f, box); }); }
    if (M.note) box.appendChild(el('p', 'kcp-photonote', M.note));
    ui.boxWrap.hidden = !box.childNodes.length;
    thumbsLater();
  }
  // dodatkowe zdjecie (np. Zdjecie (2) w Zdjeciach z dziecinstwa): pole jak w opcjach sklepu, zaraz pod poprzednim zdjeciem
  var XF = {};
  function renderX() {
    M.photos.forEach(function (d, i) {
      if (!d.x) return;
      var prev = M.photos[i - 1], pn = prev && prev.f && KCO.nodes[prev.f], w = XF[i];
      if (!w) {
        w = XF[i] = el('div', 'kcn kcn-xfield');
        if (pn && pn.parentNode) { // jeden rzad: [pole zdjecia sklepu | Zdjecie 2]
          var row = el('div', 'kcn-xrow'); pn.parentNode.insertBefore(row, pn); row.appendChild(pn); row.appendChild(w); XF['row' + i] = row;
        } else ui.boxWrap.parentNode.insertBefore(w, ui.boxWrap);
      }
      var two = !(d.show && !shown(d));
      w.hidden = !two;
      if (XF['row' + i]) XF['row' + i].classList.toggle('is-two', two);
      // etykieta pola sklepu: przy 2 zdjeciach "Zdjecie 1", przy jednym oryginalna
      var lab = pn && pn.querySelector('.kco-label');
      if (lab) { if (!lab.dataset.kcnOrig) lab.dataset.kcnOrig = lab.firstChild && lab.firstChild.nodeType === 3 ? lab.firstChild.nodeValue : ''; if (lab.firstChild && lab.firstChild.nodeType === 3) lab.firstChild.nodeValue = two ? 'Zdjęcie 1 ' : lab.dataset.kcnOrig; }
      var ph = XPH[i] ? realPhoto(i) : null, n = i + 1;
      w.innerHTML = '';
      var lr = el('div', 'kco-label-row'), lb = el('span', 'kco-label', 'Zdjęcie ' + n); lb.appendChild(el('span', 'kco-req', ' *')); lr.appendChild(lb); w.appendChild(lr);
      var up = el('label', 'kco-upload' + (ph ? ' is-filled' : ''));
      var inp = el('input'); inp.type = 'file'; inp.accept = 'image/png,image/jpeg,image/webp,image/heic'; inp.setAttribute('aria-label', 'Zdjęcie ' + n); inp.style.display = 'none';
      inp.onchange = function () { var f = inp.files && inp.files[0]; if (!f) return; XPH[i] = f; delete PHC[i]; renderBox(); draw(); };
      up.appendChild(inp);
      var idle = el('div', 'kco-upload-idle'); idle.style.display = ph ? 'none' : '';
      idle.innerHTML = '<svg viewBox="0 0 24 24" style="fill:none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 17V9"/><path d="m8.5 12 3.5-3.5L15.5 12"/><path d="M20 16.6A4.5 4.5 0 0 0 17.5 8.4 6 6 0 0 0 6 9.7a4 4 0 0 0-1.5 7.8"/></svg>';
      idle.appendChild(el('div', 'kco-upload-cta', 'Kliknij, aby dodać zdjęcie'));
      idle.appendChild(el('div', 'kco-upload-sub', 'JPG, PNG lub HEIC · prosto z telefonu'));
      up.appendChild(idle);
      var done = el('div', 'kco-upload-done'); done.style.display = ph ? '' : 'none';
      var th = el('img', 'kco-upload-thumb'); if (ph && ph.url) th.src = ph.url; done.appendChild(th);
      var cl = el('button', 'kco-upload-clear', '✕'); cl.type = 'button';
      cl.onclick = function (e) { e.preventDefault(); e.stopPropagation(); delete XPH[i]; delete PHC[i]; renderBox(); draw(); };
      done.appendChild(cl); up.appendChild(done);
      w.appendChild(up);
    });
  }
  // pola zdjec sklepu zalezne od wzoru (np. Koszulka ze zdjeciem: 'Jeden polaroid' = 1 zdjecie): ukryj zbedne i zdejmij z nich wymog
  function syncSlots() {
    M.photos.forEach(function (d) {
      if (!d.f || !d.show || !KCO.els[d.f]) return;
      var el = KCO.els[d.f], n = KCO.nodes[d.f], on = shown(d);
      if (el._kcnReq == null) el._kcnReq = !!el.required;
      el.required = on ? el._kcnReq : false;
      if (n) { n.style.display = on ? '' : 'none'; if (!on) n.classList.remove('kco-invalid'); }
    });
  }
  function placeBoxes() {
    if (!ui.boxWrap || !ui.place) return;
    var tg = ROOT.querySelector('.kco-more-tg');
    if (tg && tg.parentNode) {
      if (ui.place.nextElementSibling !== tg) tg.parentNode.insertBefore(ui.place, tg);
      if (ui.boxWrap.nextElementSibling !== ui.place) tg.parentNode.insertBefore(ui.boxWrap, ui.place);
    }
  }
  var thT = 0;
  function thumbsLater() { clearTimeout(thT); thT = setTimeout(drawThumbs, 120); }
  function drawThumbs() {
    var g = ui.thumbs, f = ui.thumbsF; if (!g || !g.isConnected) return;
    var hex = gColor().hex;
    g.querySelectorAll('.kca-thumb').forEach(function (b) {
      var c = b.querySelector('canvas'), x = c.getContext('2d'), d = data(); d[f.k] = b.dataset.o;
      if (M.tpl === 'dziecinstwo') { d.style = b.dataset.o; d.text = { walentynki: d.textV, forever: d.textF, podpis: d.textP, finding: d.textFi, forever2: d.textF2 }[b.dataset.o]; }
      var t = A.dims(M.tpl, d); x.clearRect(0, 0, c.width, c.height); x.fillStyle = hex; x.fillRect(0, 0, c.width, c.height);
      var bx = c.width * 0.86, sc = Math.min(bx / t.w, bx / t.h), w = Math.round(t.w * sc), h = Math.round(t.h * sc);
      var dc = layer(w * 2, h * 2); A.renderDesign(dc, M.tpl, Object.assign(d, { garment: hex }));
      x.drawImage(dc, (c.width - w) / 2, (c.height - h) / 2, w, h);
    });
  }

  // ---------- kadr zdjecia ----------
  var CROP = null;
  function cropGeom(ph, cw) {
    var iw = ph.img.naturalWidth || ph.img.width, ih = ph.img.naturalHeight || ph.img.height, ar = ph._ar || 1, z = ph.zoom || 1;
    var sc = Math.max(ar / iw, 1 / ih) * z, ww = ar / sc, wh = 1 / sc;
    var left = (iw - ww) * (1 + (ph.ox || 0)) / 2, top = (ih - wh) * (1 + (ph.oy || 0)) / 2, k = cw / iw;
    return { x: left * k, y: top * k, w: ww * k, h: wh * k };
  }
  function cropDraw() {
    if (!CROP || !CROP.cv.isConnected) { CROP = null; return; }
    var ph = realPhoto(CROP.i); if (!ph || !ph.img) return;
    var c = CROP.cv, x = c.getContext('2d'), g = cropGeom(ph, c.width);
    x.clearRect(0, 0, c.width, c.height); x.drawImage(ph.img, 0, 0, c.width, c.height);
    x.fillStyle = 'rgba(20,18,16,0.55)'; x.fillRect(0, 0, c.width, c.height);
    x.save(); x.beginPath(); x.rect(g.x, g.y, g.w, g.h); x.clip(); x.drawImage(ph.img, 0, 0, c.width, c.height); x.restore();
    x.strokeStyle = '#fff'; x.lineWidth = 3; x.strokeRect(g.x + 1.5, g.y + 1.5, g.w - 3, g.h - 3);
  }
  function cropEditor(i) {
    var ph = realPhoto(i), w = el('div', 'kcp-crop');
    w.appendChild(el('div', 'kcp-hint', 'Zdjęcie ' + (i + 1) + ': przesuń jasną ramkę – to, co w niej, będzie na nadruku.'));
    var iw = ph.img.naturalWidth || ph.img.width, ih = ph.img.naturalHeight || ph.img.height, cw = 640, ch = Math.round(cw * ih / iw);
    if (ch > 640) { ch = 640; cw = Math.round(640 * iw / ih); }
    var c = el('canvas', 'kcp-crop-canvas'); c.width = cw; c.height = ch; w.appendChild(c);
    var row = el('div', 'kca-scale'), r = el('input', 'kcp-range'), v = el('span', '', Math.round((ph.zoom || 1) * 100) + '%');
    r.type = 'range'; r.min = 100; r.max = 300; r.value = Math.round((ph.zoom || 1) * 100); r.setAttribute('aria-label', 'Powiększenie zdjęcia');
    r.oninput = function () { ph.zoom = r.value / 100; v.textContent = r.value + '%'; cropDraw(); draw(); thumbsLater(); };
    var lb = el('span', 'kca-scale-l', 'Przybliż'); row.appendChild(lb); row.appendChild(r); row.appendChild(v); w.appendChild(row);
    var bt = el('div', 'kca-crop-btns'), rs = el('button', 'kcp-mini', 'Wyśrodkuj zdjęcie'), ok = el('button', 'kcp-mini', 'Gotowe');
    rs.type = ok.type = 'button';
    rs.onclick = function () { ph.ox = ph.oy = 0; ph.zoom = 1; r.value = 100; v.textContent = '100%'; cropDraw(); draw(); };
    ok.onclick = function () { S.edit = null; renderBox(); };
    bt.appendChild(rs); bt.appendChild(ok); w.appendChild(bt);
    var drag = null;
    function pos(e) { var b = c.getBoundingClientRect(); return { x: (e.clientX - b.left) * c.width / b.width, y: (e.clientY - b.top) * c.height / b.height }; }
    c.addEventListener('pointerdown', function (e) { drag = { p: pos(e), g: cropGeom(ph, c.width) }; c.setPointerCapture(e.pointerId); });
    c.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var p = pos(e), g = drag.g, nx = g.x + (p.x - drag.p.x), ny = g.y + (p.y - drag.p.y), fx = c.width - g.w, fy = c.height - g.h;
      ph.ox = fx > 0.5 ? Math.max(-1, Math.min(1, 2 * nx / fx - 1)) : 0; ph.oy = fy > 0.5 ? Math.max(-1, Math.min(1, 2 * ny / fy - 1)) : 0;
      cropDraw(); draw();
    });
    function end() { if (drag) thumbsLater(); drag = null; }
    c.addEventListener('pointerup', end); c.addEventListener('pointercancel', end);
    CROP = { i: i, cv: c }; setTimeout(cropDraw, 0);
    return w;
  }

  // ================= budowa =================
  function loadScript(src) { return new Promise(function (res, rej) { var s = doc.createElement('script'); s.src = src; s.onload = res; s.onerror = function () { rej(new Error(src)); }; doc.head.appendChild(s); }); }
  function mountStage() {
    var gal = doc.querySelector('.productView-images');
    var w = el('div', 'kcn kcn-stage-wrap');
    w.innerHTML = '<div class="kca-stage"><canvas class="kcn-cv" width="1000" height="1000" aria-label="Podgląd nadruku"></canvas>' +
      '<div class="kca-badge">Na ubraniu</div><button type="button" class="kca-zoom" hidden>Przybliż nadruk</button>' +
      '<div class="kca-busy" hidden><span>Wycinamy tło ze zdjęcia…</span></div></div>' +
      '<p class="kca-demo" hidden>Teraz widzisz przykładowe zdjęcia. Wgraj swoje w opcjach produktu – podgląd zmieni się od razu.</p>' +
      '<p class="kca-note"></p><div class="kca-rooms"><div class="kca-rooms-h">zobacz na ubraniu i na osobie</div><div class="kca-rooms-g"></div></div>';
    ui.cv = w.querySelector('.kcn-cv'); ui.badge = w.querySelector('.kca-badge'); ui.zoom = w.querySelector('.kca-zoom'); ui.busy = w.querySelector('.kca-busy');
    ui.note = w.querySelector('.kca-note'); ui.rooms = w.querySelector('.kca-rooms-g'); ui.demo = w.querySelector('.kca-demo');
    if (gal) {
      gal.querySelectorAll('img').forEach(function (im) {
        var s = im.currentSrc || im.src || im.getAttribute('data-src') || ''; if (!s || /\.svg|data:/.test(s) || GALLERY.length >= 4) return;
        // jedno zdjecie = jeden plik: bez miniaturek galerii (_compact, _160x...) -> pelna jakosc, bez duplikatow
        var base = s.split('?')[0].replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)(@\dx)?(?=\.[a-z]+$)/i, '');
        if (GALLERY.some(function (g) { return g.base === base; })) return;
        var big = new Image(); big.onload = function () { draw(); }; big.src = base + '?width=1000';
        GALLERY.push({ base: base, thumb: base + '?width=200', img: big });
      });
      gal.classList.add('kcn-gal'); gal.insertBefore(w, gal.firstChild);
    } else ROOT.parentNode.insertBefore(w, ROOT);
    ui.zoom.onclick = function () { full = !full; draw(); };
    // komputer: panel przyklejony do ekranu; gdy jest wyzszy niz ekran, przyklejamy go dolna krawedzia (miniatury zawsze widoczne)
    function stick() {
      var host = (gal && getComputedStyle(gal).position === 'sticky') ? gal : w; // motyw przykleja cala kolumne galerii
      if (!global.matchMedia || !matchMedia('(min-width:990px)').matches) { host.style.top = ''; return; }
      host.style.top = Math.min(host === gal ? 30 : 90, global.innerHeight - host.offsetHeight - 12) + 'px';
    }
    ui.stick = stick; global.addEventListener('resize', stick); setTimeout(stick, 300); setTimeout(stick, 2000);
    var cv = ui.cv, drag = null;
    function cpt(e) { var b = cv.getBoundingClientRect(), s = cv.width / b.width; return { x: (e.clientX - b.left) * s + OFF.x, y: (e.clientY - b.top) * s + OFF.y }; }
    function inside(p) { var r = LAST && LAST.rect; return r && p.x >= r.x && p.x <= r.x + r.w && p.y >= r.y && p.y <= r.y + r.h; }
    cv.addEventListener('pointerdown', function (e) {
      if (view !== 'ubranie') return; var p = cpt(e); if (!inside(p)) return;
      drag = { x: p.x, y: p.y, pos: Object.assign({ x: 0, y: 0 }, LAST.pos), unit: LAST.unit, off: Object.assign({}, OFF) };
      cv.setPointerCapture(e.pointerId); cv.classList.add('grabbing'); e.preventDefault();
    });
    cv.addEventListener('pointermove', function (e) {
      if (view !== 'ubranie') { cv.classList.remove('grab'); return; }
      var p = cpt(e);
      if (!drag) { cv.classList.toggle('grab', !!inside(p)); return; }
      OFF = drag.off; S.pos = { x: drag.pos.x + (p.x - drag.x) / drag.unit, y: drag.pos.y + (p.y - drag.y) / drag.unit }; draw();
    });
    // telefon: palec na wzorze = przesuwanie wzoru, nie przewijanie strony (touch-action liczy sie przy touchstart)
    cv.addEventListener('touchstart', function (e) {
      if (view !== 'ubranie' || !e.touches || e.touches.length !== 1) return;
      if (inside(cpt(e.touches[0]))) e.preventDefault();
    }, { passive: false });
    function endDrag() { drag = null; cv.classList.remove('grabbing'); }
    cv.addEventListener('pointerup', endDrag); cv.addEventListener('pointercancel', endDrag);
  }
  function mountPanel() {
    // wielkosc i polozenie wzoru: zaraz pod "Miejsce nadruku"
    var pn = KCO.nodes['image-swatches-2'];
    var px = el('div', 'kcn kcn-place'); ui.place = px;
    px.innerHTML = '<div class="kca-sec kca-sec-h">Wielkość i położenie wzoru</div><div class="kca-scale"><span class="kca-scale-l">Wielkość wzoru</span><button type="button" class="kcn-step" data-s="-5" aria-label="Mniejszy wzór">−</button><input class="kcp-range" type="range" min="60" max="120" step="1" value="100" aria-label="Wielkość wzoru"><button type="button" class="kcn-step" data-s="5" aria-label="Większy wzór">+</button><span class="kca-scale-v">100%</span></div>' +
      '<div class="kcn-move"><span class="kca-scale-l">Położenie</span><button type="button" class="kcn-step" data-m="0,-1" aria-label="Wyżej">↑</button><button type="button" class="kcn-step" data-m="0,1" aria-label="Niżej">↓</button><button type="button" class="kcn-step" data-m="-1,0" aria-label="W lewo">←</button><button type="button" class="kcn-step" data-m="1,0" aria-label="W prawo">→</button><button type="button" class="kcp-mini">Wyśrodkuj</button></div>' +
      '<p class="kcp-hint">Możesz też przeciągnąć wzór palcem albo myszką na podglądzie.</p>';
    var rg = px.querySelector('input'), rv = px.querySelector('.kca-scale-v');
    function setScale(v) { v = Math.max(60, Math.min(120, Math.round(v))); rg.value = v; S.scale = v / 100; rv.textContent = v + '%'; if (view !== 'ubranie') view = 'ubranie'; draw(); }
    rg.oninput = function () { setScale(+rg.value); };
    px.querySelectorAll('[data-s]').forEach(function (b) { b.onclick = function () { setScale(+rg.value + +b.dataset.s); }; });
    px.querySelectorAll('[data-m]').forEach(function (b) { b.onclick = function () {
      var m = b.dataset.m.split(','), base = S.pos || (LAST && LAST.pos) || { x: 0, y: 0 };
      if (view !== 'ubranie') view = 'ubranie';
      S.pos = { x: base.x + (+m[0]), y: base.y + (+m[1]) }; draw();
    }; });
    px.querySelector('.kcp-mini').onclick = function () { S.pos = null; setScale(100); };
    if (pn && pn.parentNode) pn.parentNode.insertBefore(px, pn.nextSibling); else ROOT.insertBefore(px, ROOT.firstChild);
    // "Twój projekt": kadr zdjec, dodatkowe zdjecia, napisy i styl spoza opcji sklepu
    var bw = el('div', 'kcn kcn-box'); bw.appendChild(el('div', 'kca-sec kca-sec-h', 'Twój projekt'));
    ui.box = el('div', 'kcn-box-in'); bw.appendChild(ui.box); ui.boxWrap = bw;
    var anchor = null;
    M.photos.forEach(function (d) { if (d.f && KCO.nodes[d.f]) anchor = KCO.nodes[d.f]; });
    Object.keys(M.kco || {}).forEach(function (k) { var n = KCO.nodes[M.kco[k]]; if (n && anchor && (anchor.compareDocumentPosition(n) & 4)) anchor = n; else if (n && !anchor) anchor = n; });
    if (anchor && anchor.parentElement && anchor.parentElement.classList.contains('kco-inline-row')) anchor = anchor.parentElement; // zdjecia w jednym wierszu -> ramka pod wierszem
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(bw, anchor.nextSibling); else px.parentNode.insertBefore(bw, px.nextSibling);
  }
  function cartHook() {
    // blokada przed koszykiem: wycinanie tla w toku / brak dodatkowego zdjecia, ktorego wymaga wybrany wzor
    ROOT.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.kco-atc'); if (!b) return;
      var msg = '';
      if (M.cutout && M.photos.some(function (d, i) { var p = realPhoto(i); return p && p.img && !p.cut && !p.cutError; })) msg = 'Chwilka – jeszcze wycinamy tło ze zdjęcia.';
      var xi = -1; M.photos.forEach(function (d, i) { if (!msg && d.x && (!d.show || shown(d)) && !XPH[i]) { msg = 'Dodaj jeszcze zdjęcie ' + (i + 1) + ' – ten wzór ma 2 zdjęcia.'; xi = i; } });
      if (msg) { e.preventDefault(); e.stopImmediatePropagation(); toast(msg); (XF[xi] || ui.boxWrap).scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }, true);
    KCO.hooks.beforeSubmit = function (form) {
      function add(n, v) { var i = el('input'); i.type = 'hidden'; i.name = 'properties[' + n + ']'; i.value = v; form.appendChild(i); }
      var col = gColor(), dd = data(), pl = gPlace();
      ownFields().forEach(function (f) { var v = S.vals[f.k]; if (v == null || v === '') return; add(f.l + (f.s ? ' (styl)' : ''), f.names && f.names[v] ? f.names[v] : v); });
      var r = LAST && LAST.cm ? LAST.cm : null;
      if (!r) { var tc = layer(1000, 1000), rr = A.renderMock(tc, mockOpts(dd, col)); r = rr && rr.cm; }
      add('Położenie wzoru', pl + (r ? ', ok. ' + Math.round(r.w) + ' × ' + Math.round(r.h) + ' cm' : '') + (S.scale !== 1 ? ', wielkość ' + Math.round(S.scale * 100) + '%' : '') + (S.pos ? ', przesunięty' : ''));
      var json = { v: 2, product: PID, tpl: M.tpl, type: gType(), zip: isZip(), color: col.val, place: PLACE[pl], size: gSize(), pos: S.pos, scale: S.scale, cm: r,
        vals: Object.keys(dd).reduce(function (a, k) { if (k !== 'photos' && typeof dd[k] !== 'object') a[k] = dd[k]; return a; }, {}),
        photos: M.photos.map(function (d, i) { var p = realPhoto(i); return p ? { field: d.f ? (inputFor(d.f) || {}).dataset.kcoFile : d.x, zoom: +(p.zoom || 1).toFixed(3), ox: +(p.ox || 0).toFixed(3), oy: +(p.oy || 0).toFixed(3) } : null; }) };
      add('_kca', JSON.stringify(json));
      function fileInput(name, file) {
        try { var fi = el('input'); fi.type = 'file'; fi.name = 'properties[' + name + ']'; var dt = new DataTransfer(); dt.items.add(file); fi.files = dt.files; fi.style.display = 'none'; form.appendChild(fi); }
        catch (e) { console.warn('[kc-nadruk] plik', name, e); }
      }
      M.photos.forEach(function (d, i) { if (d.x && XPH[i] && (!d.show || shown(d))) fileInput(d.x, XPH[i]); });
      // 1) podglad na ubraniu, 2) sam projekt z przezroczystym tlem (200 DPI; plik 300 DPI zrobimy po zamowieniu z _kca)
      function png(c) { return new Promise(function (res) { c.toBlob(function (b) { res(b); }, 'image/png'); }); }
      var c = layer(1000, 1000);
      A.renderMock(c, Object.assign(mockOpts(dd, col), { shadow: false }));
      var t = A.dims(M.tpl, dd), k = 200 / 2.54, dc = layer(Math.round(t.w * k), Math.round(t.h * k));
      A.renderDesign(dc, M.tpl, Object.assign({}, dd, { garment: col.hex }));
      var stem = M.tpl + '-' + plain(col.val.split(' - ')[0]) + '-' + PLACE[pl];
      return Promise.all([png(c), png(dc)]).then(function (b) {
        if (b[0]) fileInput('Podgląd projektu', new File([b[0]], 'podglad-' + stem + '.png', { type: 'image/png' }));
        if (b[1]) fileInput('Projekt (przezroczyste tło)', new File([b[1]], 'projekt-' + stem + '.png', { type: 'image/png' }));
      });
    };
  }

  // ---------- telefon: male okienko podgladu w rogu (jak przy plakatach), gdy duzy podglad zniknie z ekranu ----------
  function mountPip() {
    if (!global.matchMedia || !matchMedia('(max-width:749px)').matches || !global.IntersectionObserver) return;
    var pv = doc.querySelector('.kcn-stage-wrap'), panel = ROOT; if (!pv || !panel) return;
    var pip = el('div', 'kcn kcn-pip'); pip.setAttribute('aria-label', 'Podgląd nadruku na żywo');
    pip.innerHTML = '<canvas></canvas><div class="kcn-pip-bar"><span>PODGLĄD</span><button type="button" class="kcn-pip-up" aria-label="Przewiń do pełnego podglądu">&uarr;</button></div>';
    doc.body.appendChild(pip);
    var c = pip.querySelector('canvas'), x = c.getContext('2d'), pvOn = true, panelOn = false, rq = 0, last = 0;
    function place() {
      var hd = doc.querySelector('.kch, header, .header'), top = 70;
      if (hd) { var r = hd.getBoundingClientRect(); top = Math.max(8, Math.min(r.bottom, 140)) + 8; }
      pip.style.top = top + 'px';
    }
    function paint(t) {
      rq = 0; if (!pip.classList.contains('is-on')) return;
      if (t - last > 150) {
        last = t; var s = ui.cv;
        if (s.width && s.height) {
          var w = Math.round(pip.clientWidth * (global.devicePixelRatio || 1)), h = Math.round(w * s.height / s.width);
          if (c.width !== w || c.height !== h) { c.width = w; c.height = h; }
          x.clearRect(0, 0, w, h); x.drawImage(s, 0, 0, w, h);
        }
      }
      rq = requestAnimationFrame(paint);
    }
    function update() { var on = !pvOn && panelOn; pip.classList.toggle('is-on', on); if (on) { place(); if (!rq) rq = requestAnimationFrame(paint); } }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.target === pv) pvOn = e.intersectionRatio > 0.25; if (e.target === panel) panelOn = e.isIntersecting; });
      update();
    }, { threshold: [0, 0.25, 0.5] });
    io.observe(pv); io.observe(panel);
    pip.addEventListener('click', function (e) {
      if (e.target.closest('.kcn-pip-up')) { pv.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      pip.classList.toggle('is-big');
    });
    global.addEventListener('scroll', function () { if (pip.classList.contains('is-on')) place(); }, { passive: true });
  }
  function toast(t) { var e = el('div', 'kca-toast', t); doc.body.appendChild(e); setTimeout(function () { e.remove(); }, 3600); }

  function boot(K) {
    KCO = K; ROOT = K.root; PID = ROOT.getAttribute('data-product-id'); M = P[PID];
    if (!M) return;
    M.fields.forEach(function (f) { S.vals[f.k] = f.def; });
    doc.documentElement.classList.add('kcn-on');
    mountStage(); mountPanel(); cartHook(); mountPip();
    [300, 1000, 2500, 5000].forEach(function (t) { setTimeout(placeBoxes, t); });
    // wiele zdjec naraz: w pierwszym polu zdjecia mozna zaznaczyc w galerii od razu wszystkie (2, 3, 4, 6...) -> rozkladamy po kolejnych polach
    var first = -1; M.photos.forEach(function (d, i) { if (first < 0 && d.f) first = i; });
    var fin = first >= 0 && inputFor(M.photos[first].f);
    if (fin && M.photos.length > 1) {
      var fnode = KCO.nodes[M.photos[first].f], hint = fnode && fnode.querySelector('.kco-upload-sub'), hint0 = hint ? hint.textContent : '';
      if (M.photos.some(function (d) { return d.x; }) && fnode) { var hp = fnode.querySelector('.kco-help'); if (hp) hp.style.display = 'none'; } // "maksymalnie trzy zdjecia" nie pasuje
      ui.multi = function () { // ile zdjec potrzebuje wybrany wzor
        var need = M.photos.filter(function (d) { return !d.show || shown(d); }).length;
        fin.multiple = need > 1;
        if (hint) hint.textContent = hint0; // user 11.10: oba pola zdjec identyczne (wybor kilku zdjec naraz dziala bez dopisku)
      };
      ui.multi();
      ROOT.addEventListener('change', function (e) {
        if (e.target !== fin || !fin.files || fin.files.length < 2) return;
        var files = Array.prototype.slice.call(fin.files), k = 1;
        for (var j = first + 1; j < M.photos.length && k < files.length; j++) {
          var d = M.photos[j];
          if (d.x) { XPH[j] = files[k++]; delete PHC[j]; continue; }
          var t = inputFor(d.f); if (!t || !vis(d.f)) continue;
          try { var dt2 = new DataTransfer(); dt2.items.add(files[k++]); t.files = dt2.files; t.dispatchEvent(new Event('change', { bubbles: true })); } catch (x) {}
        }
        try { var dt = new DataTransfer(); dt.items.add(files[0]); fin.files = dt.files; } catch (x) {}
        setTimeout(function () { renderBox(); draw(); }, 0);
      }, true);
    }
    A.setGreenscreenBase('kca:gs/'); A.setTextureBase('kca:tex/');
    global.KCApparelArt = {};
    ['tata-corka', 'tata-syn', 'mama-corka', 'mama-syn'].forEach(function (k) { kload('art/' + k + '.png').then(function (i) { global.KCApparelArt[k] = i; draw(); }); });
    var last = { type: gType(), color: gColor().val, place: gPlace() };
    KCO.on(function (id) {
      if (/^text|^kc-(word|name|since|tagline|req|date)/.test(id) || (KCO.els[id] && KCO.els[id].type === 'text')) S.touched = true;
      var now = { type: gType(), color: gColor().val, place: gPlace() };
      if (now.type !== last.type || now.place !== last.place) S.pos = null;
      if ((now.type !== last.type || now.color !== last.color || now.place !== last.place) && view !== 'ubranie' && view.indexOf('osoba:') !== 0) view = 'ubranie';
      if (now.type !== last.type) A.preload && colorsFor(now.type).forEach(function (c) { A.preload(now.type, c.val); });
      last = now; renderBox(); draw();
    });
    ROOT.addEventListener('change', function (e) { if (e.target && e.target.matches('input[data-kco-file]')) setTimeout(function () { S.edit = null; renderBox(); draw(); }, 0); }, true);
    ROOT.addEventListener('input', function (e) { if (e.target && e.target.matches('input[type=text], textarea')) { S.touched = true; draw(); } }, true);
    Promise.all([fetch(CFG.mockupy).then(function (r) { return r.json(); }), null /* user 11.10: bez widoku 'Na osobie' */]).then(function (res) {
      MAN = res[0]; OSOBA = res[1];
      A.setMockups(MAN, 'kca:mockupy/', draw);
      if (A.preload) colorsFor(gType()).forEach(function (c) { A.preload(gType(), c.val); });
      A.ensureFonts(A.TEMPLATES[M.tpl]).then(draw);
      // wolny internet: arkusz czcionek Google moze dojsc pozniej -> przerysuj po wczytaniu czcionek
      if (doc.fonts && doc.fonts.addEventListener) doc.fonts.addEventListener('loadingdone', function () { draw(); thumbsLater(); });
      renderBox(); draw();
    }).catch(function (e) { console.error('[kc-nadruk] start', e); });
  }
  function wait() {
    if (global.KCO && global.KCO.ready) return boot(global.KCO);
    doc.addEventListener('kco:ready', function () { boot(global.KCO); }, { once: true });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', wait); else wait();
})(window);
